export default __webpack_public_path__ + "static/media/block-slide-2.b3957ecb.jpg";